import { render, staticRenderFns } from "./LinkShareSettings.vue?vue&type=template&id=8f82016a&scoped=true"
import script from "./LinkShareSettings.vue?vue&type=script&lang=js"
export * from "./LinkShareSettings.vue?vue&type=script&lang=js"
import style0 from "./LinkShareSettings.vue?vue&type=style&index=0&id=8f82016a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f82016a",
  null
  
)

export default component.exports